import React, {useState} from 'react';
import {Button} from 'antd';
import {UpOutlined, DownOutlined} from '@ant-design/icons';

import './showMoreCmp.less';

const ShowMoreCmp = ({previewContent, all, style}) => {
  const [isShowMore, setShowMore] = useState(false);

  return (<div style={style}>
    {
      !isShowMore ? 
      (<div className="ShowMoreCmp">
        {previewContent} 
        <div className="center">
          <div className="Btn-Link" onClick={() => setShowMore(true)}>Read more	&nbsp;<DownOutlined /></div>
        </div>
      </div>) 
      : (<div className="ShowMoreCmp">
        {all} 
        <div className="center">
          <div onClick={() => setShowMore(false)} className="Btn-Link">Show less 	&nbsp;<UpOutlined /></div>
        </div>
      </div>)
    }
  </div>);
}
export default ShowMoreCmp;
